import { GetManyQueryDto } from '../../../classes/common';
import { PartialType } from '../../../utils';
export class GetManyBranchesQueryDto extends PartialType(GetManyQueryDto) {
}
